export const TOGGLE_NAME = "TOGGLE_NAME";
